import React from 'react';

import * as dataCollectionTypes from '../../../../consts/uam/dataCollectionTypes';
import DataCollectionBaseHandler from './DataCollectionBaseHandler';

const DataCollectionUsageHandler = () => {
    return <DataCollectionBaseHandler dataCollectionType={dataCollectionTypes.DATA_COLLECTION_USAGE} />;
};

export default DataCollectionUsageHandler;
